




























import { Component, Vue } from 'vue-property-decorator'
import momentTz from 'moment-timezone'
import { AMERICA_TIMEZONE } from '@zunta/configurations'

@Component({})
export default class LoginPage extends Vue {
  reloadPage () {
    window.location.href = '/login'
  }

  get backAt () {
    return momentTz.tz('2025-05-11 04:00', AMERICA_TIMEZONE).format('MM/DD/YYYY hh:mm') + ' EDT'
  }
}
